module.exports = __webpack_public_path__ + "static/404-18da90e6c66685580a7ba041d72b1165.svg";